export const environment = {
  production: false,
  // API_BASE_URL: 'https://invento.ovaku.in/api/public',
  API_BASE_URL: 'https://devinvento.ovaku.in/api/public',
  COMPANY_LOGO_SIZE: 2 * 1024 * 1024, //2 mb limit for company logo
  CATEGORIES: [
    {
      name: 'Laptop',
      companies: ['Dell', 'HP', 'Lenovo', 'Asus', 'Acer', 'Apple', 'MSI', 'Microsoft', 'Samsung', 'LG', 'Razer', 'Huawei', 'Xiaomi', 'Chuwi', 'Toshiba', 'Panasonic', 'Sony', 'VAIO', 'Crompton', 'Other']
    },
    {
      name: 'Mobile',
      companies: ['Samsung', 'Apple', 'OnePlus', 'Xiaomi', 'Mi', 'Redmi', 'Poco', 'Realme', 'Motorola', 'Google', 'Huawei', 'Honor', 'Nokia', 'Asus', 'Lenovo', 'Infinix', 'Tecno', 'Lava', 'Micromax', 'iQOO', 'Vivo', 'Oppo', 'Nothing', 'Fairphone', 'Sony', 'ZTE', 'Meizu', 'Gionee', 'Panasonic', 'Philips', 'Karbonn', 'iBall', 'Other']
    },
    {
      name: 'Speaker',
      companies: ['JBL', 'Sony', 'Bose', 'Boat', 'Marshall', 'Zebronics', 'Philips', 'Other']
    }
  ]
};
